import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaType } from '../../enums/multimedia-type';

@jsonObject
export class MultimediaResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly title!: string;

  @jsonMember(String)
  public readonly extension!: string;

  @jsonMember(String)
  public readonly url!: string;

  @jsonMember(String)
  public readonly alternativeText?: Nillable<string>;

  @jsonMember(String)
  public readonly downloadUrl?: Nillable<string>;

  @jsonMember(String)
  public readonly type?: Nillable<MultimediaType>;

  public alt(): string {
    return this.alternativeText ?? this.title;
  }
}
